import { ComponentData, ActivityBlueprintData, ContainerManifestEntry } from '@fluidx/office-fluid-types';

export function isComponentData(data: any): data is ComponentData {
  return (data as ComponentData).isComponentData;
}

export function isActivityBlueprintData(data: any): data is ActivityBlueprintData {
  return (data as ActivityBlueprintData).isActivityBlueprintData;
}

export function isContainerManifestEntry(data: any): data is ContainerManifestEntry {
  return (data as ContainerManifestEntry).codeDetails !== undefined;
}
